import { usePermissions } from 'permissions';
import { Card } from 'ui';
import { type EventFeedbackOptions, TelehealthRequest } from 'features/events';
import { TodosWidget, TodosWidgetProvider } from 'features/todos';

type P = {
  feedbackOptions: EventFeedbackOptions;
  hideTodosFeedCta: boolean;
};

const Sidebar = ({ feedbackOptions, hideTodosFeedCta }: P) => {
  const { canRequestTelehealthEvent } = usePermissions();

  return (
    <div className="main-sidebar">
      {canRequestTelehealthEvent({}) ? (
        <Card className="main-sidebar__telehealth">
          <TelehealthRequest buttonType="secondary" />
        </Card>
      ) : null}
      <TodosWidgetProvider>
        <TodosWidget
          className="main-sidebar__todos"
          feedbackOptions={feedbackOptions}
          hideTodosFeedCta={hideTodosFeedCta}
        />
      </TodosWidgetProvider>
    </div>
  );
};

export default Sidebar;
